/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfWarehouseDto } from '../../models/paginated-dto-of-warehouse-dto';

export interface GetWarehouses$Params {
  name?: string;
  limit?: number;
  settlementId: string;
}

export function getWarehouses(http: HttpClient, rootUrl: string, params: GetWarehouses$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfWarehouseDto>> {
  const rb = new RequestBuilder(rootUrl, getWarehouses.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('limit', params.limit, {});
    rb.query('settlementId', params.settlementId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfWarehouseDto>;
    })
  );
}

getWarehouses.PATH = '/api/v1/warehouses';
